import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { authorizeToken } from './guards'

Vue.use(VueRouter)

// ルーター生成
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // ブラウザの進む／戻るは変更しない
      return savedPosition
    } else {
      // それ以外は画面トップに移動
      return { x: 0, y: 0 }
    }
  }
})

// ナビゲーションガード設定
router.beforeEach(authorizeToken)

export default router
